import { Policy } from '@commandDrivenStateEngine/core/policies';
import { AccountState } from '../state';
import { AccountCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';

/**
 * Order Statuses Sync Policy
 *
 * Responsibilities:
 * - On mount, load the order-statuses catalog via SalesOrderStatuses() and
 *   dispatch account/orderStatuses/setData.
 *
 * Reads through the `SalesOrderStatuses` query — NOT `SalesAccountConfigurationById`.
 * `SalesOrderStatuses` returns the account's configured catalog when one exists
 * and otherwise falls back to the canonical `defaultOrderStatuses` (server-side).
 * `SalesAccountConfigurationById` is the raw projection with no fallback, so it
 * returns null until the account saves a set — which rendered this editor empty
 * for every un-configured account. This is the same query the Orders list and the
 * channel status-mapping editor read, so the settings editor now shows the same
 * statuses (the defaults for a fresh account), editable and persisted on first save.
 *
 * Mirrors `createSkuConfigSyncPolicy`.
 */
export const createOrderStatusesSyncPolicy = (
  backend: ClientLibraryType
): Policy<AccountState, AccountCommand> => ({
  name: 'order-statuses-sync',

  init: ({ dispatch }) => {
    ( async () => {
      try {
        const statuses = await backend.queries.SalesOrderStatuses();

        dispatch(
          {
            type: 'account/orderStatuses/setData',
            payload: { statuses: statuses ?? []}
          },
          { source: 'api' }
        );
      } catch ( error ) {
        console.error( '[account] order-statuses-sync error:', error );
      }
    })();
  }
});
